import React, { useState } from "react";
import {
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  Stack,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { createStyledIndicatorButton } from "../../../common/StyledComponents/SideBarComponents";
import infoIcon from "../../../assets/images/chats/infoIcon.svg";
import {
  AccountLevelArkchatPermission,
  GroupLevelArkchatPermission,
  InviteType,
  MessageType,
} from "../../../utils/constant";
import useAppSelectors from "../../../customHooks/useAppSelectors";
import { useTranslation } from "react-i18next";
import {
  fontSizeSchemes,
  crossIcon,
  crossIconDiv,
} from "../../../assets/commonFunction";
import AlertPopUp from "../../../common/AlertPopUp";
import PersonIcon from "../../../assets/images/chats/person.svg";
import PersonIconDisabled from "../../../assets/images/chats/personDisable.svg";
import SelectCheckBox from "../../../assets/images/chats/selectcheckbox.svg";
import session from "../../../utils/helper";

const checkboxIconStyle = {
  width: 25,
  height: 25,
  display: "block",
};
const memberIndicatorStyle = {
  width: "25px",
  height: "25px",
  minWidth: "25px",
  minHeight: "25px",
  color: "#183243",
  padding: 0,
  overflow: "hidden",
};
const classes = {
  drawerBody: {
    minWidth: "31.25rem",
    maxWidth: "31.25rem",
    display: "flex",
    justifyContent: "space-between",
    flexDirection: "column",
    height: "100%",
  },
  header: {
    backgroundColor: "#F9F8F8",
    color: "#0000",
    padding: "7px 8px",
  },
  iconDiv: crossIconDiv,
  iconn: crossIcon,
  radiogp: {
    display: "block",
  },
};

const UserListDrawer = ({
  groupMemberData,
  internalMemebrData,
  externalMemberData,
  externalGroupRecipient,
  externalGroupMember,
  handleSelectCompanyAllRecipients,
  handleSelectExternalRecipients,
  handleClostRecipientsDrawer,
  handleSelectedRecipients,
  selectedRecipients,
  handleCLickTodo,
  isDisableAssignTaskBtn,
  taskModalDeatils,
  msgType,
  taskData,
  chatInputControl
}) => {
  const NameBadge = createStyledIndicatorButton("#E3E1E1");
  const { t } = useTranslation();
  const appContent = t("AppContent", { returnObjects: true });
  const { currentUserData, threadMsgList } = useAppSelectors();
  const [isAlertModalOpen, setAlertModalOpen] = useState(false);
  const isThreadScreen = session.get("isThreadScreen");

  const getDisableTaskApproveButton = (memberData, type) => {
    if (msgType === MessageType?.Approval) {
      if (type === "internal") {
        return memberData?.userId === currentUserData?.id
          ? true
          : !isDisableAssignTaskBtn;
      } else {
        return memberData?.userId === currentUserData?.id
          ? true
          : !isDisableAssignTaskBtn;
      }
    }
    return !isDisableAssignTaskBtn;
  };
  return (
    <React.Fragment>
      <AlertPopUp
        title={"Alert"}
        bodyContent={appContent?.KEY294}
        open={isAlertModalOpen}
        closeModal={setAlertModalOpen}
      />
      <Box sx={classes.drawerBody}>
        <Stack>
          <Stack
            direction="row"
            alignItems="center"
            spacing={2}
            sx={classes.header}
          >
            <Typography sx={classes.iconDiv}>
              <CloseIcon
                sx={classes.iconn}
                onClick={handleClostRecipientsDrawer}
              />
            </Typography>
            <Typography
              fontSize={fontSizeSchemes.font18}
              fontWeight={400}
              color={"black"}
            >
              {taskModalDeatils?.title}
            </Typography>
          </Stack>
          <Box
            mt={"0.5rem"}
            overflow={"scroll"}
            height={"calc(100vh - 14rem)"}
            sx={{
              "&::-webkit-scrollbar": {
                width: "2px",
                padding: "0px 2px",
              },
              "&::-webkit-scrollbar-track": {
                background: "#F9F8F8",
              },
              "&::-webkit-scrollbar-thumb": {
                background: "grey",
              },
            }}
          >
            <Box padding="0px 19px 0px 12px">
              <Typography
                fontSize={fontSizeSchemes.font14}
                fontWeight={400}
                color={"black"}
              >
                {taskModalDeatils?.subHeader}
              </Typography>
            </Box>
            {groupMemberData?.internalMember?.length > 0 &&
              groupMemberData?.internalMember?.map((memberData, i) => (
                <Box key={memberData.userId + "recipientList"}>
                  {i === 0 && (
                    <>
                      <Stack
                        direction="row"
                        justifyContent="space-between"
                        alignItems="center"
                        spacing={1}
                        padding="0px 19px 0px 12px"
                      >
                        <FormControlLabel
                          sx={{
                            ".MuiFormControlLabel-label": {
                              fontWeight: 500,
                              color: "#000000",
                            },
                          }}
                          control={
                            <Checkbox
                              sx={{
                                "& .MuiSvgIcon-root": {
                                  fontSize: 30,
                                  color: "#183243",
                                },
                              }}
                              // disabled={
                              //   isThreadScreen &&
                              //   selectedRecipients?.selectedInternalRecipients
                              //     ?.length +
                              //     selectedRecipients?.selectedExternalRecipients
                              //       ?.length ===
                              //     internalMemebrData?.length +
                              //       externalGroupRecipient?.length
                              // }
                              checked={
                                selectedRecipients?.selectedInternalRecipients
                                  ?.length +
                                  selectedRecipients?.selectedExternalRecipients
                                    ?.length ===
                                internalMemebrData?.length +
                                  externalGroupRecipient?.length
                              }
                              onChange={(event) =>
                                handleSelectedRecipients(
                                  event,
                                  null,
                                  "AllMember",
                                )
                              }
                              checkedIcon={
                                <img
                                  style={checkboxIconStyle}
                                  src={SelectCheckBox}
                                  alt="selected"
                                />
                              }
                              icon={
                                <NameBadge
                                  sx={memberIndicatorStyle}
                                  size="small"
                                  variant="contained"
                                >
                                  <img src={PersonIcon} alt="all" />
                                  {/* <Typography
                                    color={"#183243"}
                                    fontSize={"0.75rem"}
                                    fontWeight={600}
                                  >
                                    A
                                  </Typography> */}
                                </NameBadge>
                              }
                            />
                          }
                          label={
                            <Typography
                              maxWidth={"25rem"}
                              overflow={"hidden"}
                              textOverflow={"ellipsis"}
                              whiteSpace={"nowrap"}
                              fontSize={fontSizeSchemes.font16}
                              fontWeight={500}
                            >
                              All Group Members
                            </Typography>
                          }
                        />
                      </Stack>

                      <Stack
                        direction="row"
                        justifyContent="space-between"
                        alignItems="center"
                        spacing={1}
                        padding="0px 19px 0px 12px"
                      >
                        <FormControlLabel
                          sx={{
                            ".MuiFormControlLabel-label": {
                              fontWeight: 600,
                              color: "#000000",
                            },
                          }}
                          control={
                            <Checkbox
                              sx={{
                                "& .MuiSvgIcon-root": {
                                  fontSize: 30,
                                  color: "#183243",
                                },
                              }}
                              // disabled={
                              //   isThreadScreen &&
                              //   (selectedRecipients?.selectedInternalRecipients
                              //     ?.length +
                              //     selectedRecipients?.selectedExternalRecipients
                              //       ?.length ===
                              //     internalMemebrData?.length +
                              //       externalGroupRecipient?.length ||
                              //     selectedRecipients
                              //       ?.selectedInternalRecipients?.length ===
                              //       internalMemebrData?.length)
                              // }
                              checked={
                                selectedRecipients?.selectedInternalRecipients
                                  ?.length === internalMemebrData?.length
                              }
                              onChange={(e) =>
                                handleSelectedRecipients(e, null, "MyTeam")
                              }
                              checkedIcon={
                                <img
                                  style={checkboxIconStyle}
                                  src={SelectCheckBox}
                                  alt="selected"
                                />
                              }
                              icon={
                                <NameBadge
                                  sx={memberIndicatorStyle}
                                  size="small"
                                  variant="contained"
                                >
                                  {/* <Typography
                                    color={"#183243"}
                                    fontSize={"0.75rem"}
                                    fontWeight={600}
                                  >
                                    {
                                      currentUserData?.activeSubscriber
                                        ?.subscriberFirmName[0]
                                    }
                                  </Typography> */}
                                  <img src={PersonIcon} alt="all" />
                                </NameBadge>
                              }
                            />
                          }
                          label={
                            <Typography
                              title={
                                currentUserData?.activeSubscriber
                                  ?.subscriberFirmName
                              }
                              maxWidth={"25rem"}
                              overflow={"hidden"}
                              textOverflow={"ellipsis"}
                              whiteSpace={"nowrap"}
                              fontSize={fontSizeSchemes.font16}
                              fontWeight={500}
                            >
                              My Team
                            </Typography>
                          }
                        />
                      </Stack>
                    </>
                  )}
                  {memberData?.permissionType !==
                    GroupLevelArkchatPermission?.REMOVE && (
                    <Stack
                      direction="row"
                      justifyContent="space-between"
                      alignItems="center"
                      spacing={1}
                      padding={"0rem 0.7rem 0rem 2rem"}
                    >
                      <FormControlLabel
                        sx={{
                          ".MuiFormControlLabel-label": {
                            fontSize: "0.78rem !important",
                            color: "#000000",
                          },
                        }}
                        control={
                          <Checkbox
                            sx={{
                              "& .MuiSvgIcon-root": {
                                fontSize: 25,
                                color: "#183243",
                              },
                            }}
                            disabled={
                              (isThreadScreen &&
                                threadMsgList[0]?.participants?.includes(
                                  memberData.userId,
                                )) ||
                              (taskData?.participants?.includes(
                                  memberData.userId,
                                )) ||
                              (memberData?.userId === currentUserData?.id &&
                                msgType === MessageType?.Approval)
                            }
                            onChange={(e) =>
                              handleSelectedRecipients(e, memberData)
                            }
                            checked={selectedRecipients?.selectedInternalRecipients?.some(
                              (item) =>
                                item && item?.userId === memberData.userId,
                            )}
                            checkedIcon={
                              <img
                                style={checkboxIconStyle}
                                src={SelectCheckBox}
                                alt="selected"
                              />
                            }
                            icon={
                              <NameBadge
                                sx={{
                                  ...memberIndicatorStyle,
                                  color: "#183243",
                                  padding: memberData?.userInfo?.profileImgUrl
                                    ? "0rem"
                                    : "0rem",
                                  }}
                                size="small"
                                variant="contained"
                              >
                                {memberData?.userInfo?.profileImgUrl ? (
                                  <img
                                    style={{ width: "100%", height: "100%" }}
                                    src={memberData?.userInfo?.profileImgUrl}
                                    alt={memberData?.userInfo?.firstName}
                                  />
                                ) : (
                                  <img
                                    src={
                                      memberData?.userId ===
                                        currentUserData?.id &&
                                      msgType === MessageType?.Approval
                                        ? PersonIconDisabled
                                        : PersonIcon
                                    }
                                    alt="all"
                                  />
                                  // <Typography
                                  //   color={"#183243"}
                                  //   fontSize={"0.75rem"}
                                  // >
                                  //   {memberData?.userInfo?.firstName &&
                                  //     memberData?.userInfo?.firstName[0]}
                                  // </Typography>
                                )}
                              </NameBadge>
                            }
                          />
                        }
                        label={
                          <Box
                            display={"flex"}
                            alignItems={"center"}
                            gap={"0.15rem"}
                          >
                            <Typography
                              title={`${memberData?.userInfo?.firstName} ${memberData?.userInfo?.lastName}`}
                              maxWidth={"20rem"}
                              overflow={"hidden"}
                              textOverflow={"ellipsis"}
                              whiteSpace={"nowrap"}
                              fontSize={fontSizeSchemes.font14}
                              fontWeight={400}
                            >
                              {`${memberData?.userInfo?.firstName} ${memberData?.userInfo?.lastName}`}
                              <>,</>
                            </Typography>
                            {(() => {
                              if (
                                memberData?.permission ===
                                  AccountLevelArkchatPermission?.ADMIN &&
                                memberData?.inviteType ===
                                  InviteType?.ownerInviteType
                              ) {
                                return (
                                  <Typography fontSize={"0.7rem"}>
                                    Owner
                                  </Typography>
                                );
                              } else if (
                                memberData?.permission ===
                                  AccountLevelArkchatPermission?.ADMIN &&
                                memberData?.inviteType === InviteType?.internal
                              ) {
                                return (
                                  <Typography fontSize={"0.7rem"}>
                                    Admin
                                  </Typography>
                                );
                              } else {
                                return (
                                  <Typography fontSize={"0.7rem"}>
                                    User
                                  </Typography>
                                );
                              }
                            })()}
                            {!memberData?.userInfo?.membership && (
                              <>
                                <Box
                                  ml="0.4rem"
                                  sx={{
                                    height: "0.5rem",
                                    width: "0.5rem",
                                    borderRadius: "50%",
                                    bgcolor: "red",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    display: "flex",
                                  }}
                                />
                                <img
                                  onClick={() => {
                                    setAlertModalOpen(true);
                                  }}
                                  src={infoIcon}
                                  alt="info"
                                  style={{
                                    height: "1rem",
                                    width: "1rem",
                                    marginLeft: "0.25rem",
                                    cursor: "pointer",
                                  }}
                                />
                              </>
                            )}
                          </Box>
                        }
                      />
                      {taskModalDeatils?.buttonname !== "" && (
                        <Button
                          disabled={getDisableTaskApproveButton(
                            memberData,
                            "internal",
                          )}
                          onClick={() => handleCLickTodo(memberData)}
                          variant="outlined"
                          sx={{
                            backgroundColor: "#fff",
                            borderRadius: "3px",
                            padding: "0px 7px",
                            textTransform: "none",
                            color: "#183243",
                            borderColor: "#183243",
                            fontSize: fontSizeSchemes.font14,
                            fontWeight: 400,
                            ":hover": {
                              color: "#183243",
                              borderRadius: "3px",
                              borderColor: "#183243",
                            },
                          }}
                        >
                          {taskModalDeatils?.buttonname}
                        </Button>
                      )}
                    </Stack>
                  )}
                </Box>
              ))}
            <Box>
              {externalMemberData.map((company, index) => (
                <Box key={index + "externalRecipientGroup"}>
                  <Stack
                    direction="row"
                    justifyContent="space-between"
                    alignItems="center"
                    spacing={1}
                    padding="0px 19px 0px 12px"
                  >
                    <FormControlLabel
                      sx={{
                        ".MuiFormControlLabel-label": {
                          fontWeight: 600,
                          color: "#000000",
                        },
                      }}
                      control={
                        <Checkbox
                          sx={{
                            "& .MuiSvgIcon-root": {
                              fontSize: 30,
                              color: "#183243",
                            },
                          }}
                          // disabled={
                          //   isThreadScreen &&
                          //   (selectedRecipients?.selectedInternalRecipients
                          //     ?.length +
                          //     selectedRecipients?.selectedExternalRecipients
                          //       ?.length ===
                          //     internalMemebrData?.length +
                          //       externalGroupRecipient?.length ||
                          //     Object.values(company)[0]?.length ===
                          //       externalGroupMember[Object.keys(company)[0]]
                          //         ?.length)
                          // }
                          checked={
                            Object.values(company)[0]?.length ===
                            externalGroupMember[Object.keys(company)[0]]?.length
                          }
                          onChange={(event) =>
                            handleSelectCompanyAllRecipients(
                              event,
                              company,
                              Object.keys(company)[0],
                            )
                          }
                          checkedIcon={
                            <img
                              style={checkboxIconStyle}
                              src={SelectCheckBox}
                              alt="selected"
                            />
                          }
                          icon={
                            <NameBadge
                              sx={memberIndicatorStyle}
                              size="small"
                              variant="contained"
                            >
                              {/* <Typography
                                color={"#183243"}
                                fontSize={"0.75rem"}
                                fontWeight={600}
                              >
                                {Object.keys(company)[0] &&
                                  Object.keys(company)[0][0]}
                              </Typography> */}
                              <img src={PersonIcon} alt="all" />
                            </NameBadge>
                          }
                        />
                      }
                      label={
                        <Typography
                          title={Object.keys(company)[0]}
                          maxWidth={"25rem"}
                          overflow={"hidden"}
                          textOverflow={"ellipsis"}
                          whiteSpace={"nowrap"}
                          fontSize={"0.88rem"}
                          fontWeight={600}
                        >
                          {Object.keys(company)[0]}
                        </Typography>
                      }
                    />
                  </Stack>

                  {Object.values(company)[0]?.map((item, i) => (
                    <Stack
                      key={i + "externalRecipientGroupCompany"}
                      direction="row"
                      justifyContent="space-between"
                      alignItems="center"
                      spacing={1}
                      padding={"0rem 0.7rem 0rem 2rem"}
                    >
                      <FormControlLabel
                        sx={{
                          ".MuiFormControlLabel-label": {
                            fontSize: "0.78rem !important",
                            color: "#000000",
                          },
                        }}
                        control={
                          <Checkbox
                            sx={{
                              "& .MuiSvgIcon-root": {
                                fontSize: 25,
                                color: "#183243",
                              },
                            }}
                            disabled={
                              (isThreadScreen &&
                                threadMsgList[0]?.participants?.includes(
                                  item.userId,
                                )) ||
                              (taskData?.participants?.includes(item.userId))
                            }
                            onChange={(event) =>
                              handleSelectExternalRecipients(
                                event,
                                item,
                                Object.keys(company)[0],
                                Object.values(company)[0],
                              )
                            }
                            checked={selectedRecipients?.selectedExternalRecipients?.some(
                              (user) =>
                                user && item && user.userId === item.userId,
                            )}
                            checkedIcon={
                              <img
                                style={checkboxIconStyle}
                                src={SelectCheckBox}
                                alt="selected"
                              />
                            }
                            icon={
                              <NameBadge
                                sx={memberIndicatorStyle}
                                size="small"
                                variant="contained"
                              >
                                <img src={PersonIcon} alt="all" />
                                {/* <Typography
                                  color={"#183243"}
                                  fontSize={"0.75rem"}
                                >
                                  {item?.firstName && item?.firstName[0]}
                                </Typography> */}
                              </NameBadge>
                            }
                          />
                        }
                        label={
                          <Box
                            display={"flex"}
                            alignItems={"center"}
                            gap={"0.15rem"}
                          >
                            <Typography
                              title={`${item?.firstName} ${item?.lastName}`}
                              maxWidth={"20rem"}
                              overflow={"hidden"}
                              textOverflow={"ellipsis"}
                              whiteSpace={"nowrap"}
                              fontSize={fontSizeSchemes.font14}
                              fontWeight={400}
                            >
                              {`${item?.firstName} ${item?.lastName}`}
                              <>,</>
                            </Typography>
                            {(() => {
                              if (
                                item?.accountPermission ===
                                AccountLevelArkchatPermission?.ADMIN
                              ) {
                                if (
                                  item?.inviteType ===
                                  InviteType?.ownerInviteType
                                ) {
                                  return (
                                    <Typography fontSize={"0.7rem"}>
                                      Owner
                                    </Typography>
                                  );
                                } else {
                                  return (
                                    <Typography fontSize={"0.7rem"}>
                                      Admin
                                    </Typography>
                                  );
                                }
                              } else {
                                return (
                                  <Typography fontSize={"0.7rem"}>
                                    User
                                  </Typography>
                                );
                              }
                            })()}
                            {/* {item?.accountPermission ===
                              AccountLevelArkchatPermission?.ADMIN &&
                              (item?.inviteType === InviteType?.ownerInviteType) && (
                                <Typography fontSize={"0.7rem"}>
                                  Owner
                                </Typography>
                              )}
                              {item?.accountPermission ===
                              AccountLevelArkchatPermission?.ADMIN &&
                              (item?.inviteType !== InviteType?.ownerInviteType) && (
                                <Typography fontSize={"0.7rem"}>
                                  Admin
                                </Typography>
                              )} */}
                            {!item?.membership && (
                              <>
                                <Box
                                  ml="0.4rem"
                                  sx={{
                                    height: "0.5rem",
                                    width: "0.5rem",
                                    borderRadius: "50%",
                                    bgcolor: "red",
                                  }}
                                />
                                <img
                                  src={infoIcon}
                                  alt="info"
                                  style={{
                                    height: "1rem",
                                    width: "1rem",
                                    marginLeft: "0.25rem",
                                    cursor: "pointer",
                                  }}
                                />
                              </>
                            )}
                          </Box>
                        }
                      />
                      {taskModalDeatils?.buttonname !== "" && (
                        <Button
                          disabled={getDisableTaskApproveButton(
                            item,
                            "external",
                          )}
                          onClick={() => handleCLickTodo(item, false)}
                          variant="outlined"
                          sx={{
                            backgroundColor: "#fff",
                            borderRadius: "3px",
                            padding: "0px 7px",
                            textTransform: "none",
                            color: "#183243",
                            borderColor: "#183243",
                            fontSize: fontSizeSchemes.font14,
                            fontWeight: 400,
                            ":hover": {
                              color: "#183243",
                              borderRadius: "3px",
                              borderColor: "#183243",
                            },
                          }}
                        >
                          {taskModalDeatils?.buttonname}
                        </Button>
                      )}
                    </Stack>
                  ))}
                </Box>
              ))}
            </Box>
          </Box>
        </Stack>
      </Box>
      {(isThreadScreen&&taskModalDeatils?.msgType===MessageType?.Direct_Mesage) && <Box padding="0px 19px 0px 12px">{chatInputControl({ hideSuggestBtn: true })}</Box>}
    </React.Fragment>
  );
};

export default UserListDrawer;
